import React, { useState } from 'react';
import styles from './Contact.module.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '+91',
    inquiryType: 'General Inquiry',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message sent successfully!');
    setFormData({
      fullName: '',
      email: '',
      phone: '+91 98765 43210',
      inquiryType: 'General Inquiry',
      subject: '',
      message: ''
    });
  };

  const inquiryTypes = [
    'General Inquiry',
    'Technical Support',
    'Sales Question',
    'Partnership',
    'Feedback',
    'Other'
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Contact Us</h1>
        <p className={styles.subtitle}>
          Send us a message and we'll get back to you as soon as possible.
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          {/* First Row: Two inputs side by side */}
          <div className={styles.row}>
            <div className={styles.column}>
              <label htmlFor="fullName" className={styles.label}>
                Full Name <span className={styles.required}>*</span>
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                className={styles.input}
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className={styles.column}>
              <label htmlFor="email" className={styles.label}>
                Email Address <span className={styles.required}>*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className={styles.input}
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Second Row: Phone and Inquiry Type side by side */}
          <div className={styles.row}>
            <div className={styles.column}>
              <label htmlFor="phone" className={styles.label}>
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className={styles.input}
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            
            <div className={styles.column}>
              <label htmlFor="inquiryType" className={styles.label}>
                Inquiry Type <span className={styles.required}>*</span>
              </label>
              <select
                id="inquiryType"
                name="inquiryType"
                className={styles.select}
                value={formData.inquiryType}
                onChange={handleChange}
                required
              >
                {inquiryTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Third Row: Subject full width */}
          <div className={styles.fullWidth}>
            <label htmlFor="subject" className={styles.label}>
              Subject <span className={styles.required}>*</span>
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              className={styles.input}
              placeholder="Brief description of your inquiry"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          {/* Fourth Row: Message full width */}
          <div className={styles.fullWidth}>
            <label htmlFor="message" className={styles.label}>
              Message <span className={styles.required}>*</span>
            </label>
            <textarea
              id="message"
              name="message"
              className={styles.textarea}
              placeholder="Please provide detailed information about your inquiry..."
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            />
          </div>

          <button type="submit" className={styles.button}>
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;